"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Carousel = _interopRequireDefault(require("react-bootstrap/lib/Carousel"));
var prevIcon = /*#__PURE__*/_react["default"].createElement("span", {
  className: "icon icon-left-open-big"
});
var nextIcon = /*#__PURE__*/_react["default"].createElement("span", {
  className: "icon icon-right-open-big"
});
var Carousel = function Carousel(props) {
  return /*#__PURE__*/_react["default"].createElement(_Carousel["default"], (0, _extends2["default"])({
    prevIcon: prevIcon,
    nextIcon: nextIcon
  }, props));
};
Carousel.Item = _Carousel["default"].Item;
Carousel.Caption = _Carousel["default"].Caption;
var _default = exports["default"] = Carousel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Carousel.js
// module id = 1702
// module chunks = 25